import React from 'react';
import { useTranslation } from 'react-i18next';
import ActivityRow from '../../dashboard/components/ActivityRow';
import { cn } from '../../../utils/cn';

const AlertsTable = ({ activities, className, emptyMessage }) => {
  const { t } = useTranslation();
  const empty = emptyMessage ?? t('alerts.noAlerts');

  if (!activities?.length) {
    return (
      <div className={cn('bg-card border border-border rounded-lg p-8 text-center', className)}>
        <p className="text-muted-foreground">{empty}</p>
      </div>
    );
  }

  return (
    <div className={cn('bg-card border border-border rounded-lg overflow-hidden', className)}>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {t('alerts.tableCandidate')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                {t('alerts.tableActivity')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                {t('alerts.tableType')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                {t('alerts.tableTime')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {activities.map((activity) => (
              <ActivityRow key={activity.id} activity={activity} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AlertsTable;
